module.exports = __webpack_public_path__ + "llc_partner.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/llc_partner.svg
// module id = 470
// module chunks = 0